export default {
  cartonSymbols: [],
  cartonSymbol: undefined,
};
